// createManager.js
import axiosInstance from 'services/axiosMiddleware';

export async function createManager(userdata) {
  try {
    const response = await axiosInstance.post('users/create-manager', userdata);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}